export const ruleEngineMenuDef = [
    {
        name: 'menu.rule_definition',
        resource: 'rule_definition_facility',
        icon: 'fa fa-h-square',
        url: 'rule_definition_facility',
        breadcrumb: "rule_definition",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.rule_definition',
        resource: 'rule_definition_account',
        icon: 'fa fa-h-square',
        url: 'rule_definition_account',
        breadcrumb: "rule_definition",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.rule_definition',
        resource: 'rule_definition',
        icon: 'fa fa-h-square',
        url: 'rule_definition',
        breadcrumb: "rule_definition",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.rules_fields_master',
        resource: 'rules_fields_master',
        icon: 'fa fa-h-square',
        url: 'rules_fields_master',
        breadcrumb: "rules_fields_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.action_master',
        resource: 'button_master',
        icon: 'fa fa-h-square',
        url: 'button_master',
        breadcrumb: "button_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.tag_master',
        resource: 'tag_master',
        icon: 'fa fa-h-square',
        url: 'tag_master',
        breadcrumb: "button_master",
        auto_crud: true,
        showMenu: true
    },
    {
        name: 'menu.team',
        resource: 'team',
        url: 'team',
        auto_crud: true
    },
    {
        name: 'menu.team_members',
        resource: 'team_members',
        url: 'team_members',
        auto_crud: true
    },
    {
        name: 'menu.team_query_master',
        resource: 'team_query_master',
        url: 'team_query_master',
        auto_crud: true
    }
]